import MediaQueryEvent from '@/components/media-query-event';

const imageSwapElements = document.querySelectorAll('.js-image-swap');
const { editmode } = window.mds || {};

if (imageSwapElements.length && !editmode && MediaQueryEvent.atLeast('lg')) {
  imageSwapElements.forEach((swapElement) => {
    const swapImageTarget = swapElement.querySelector('.js-image-swap-target');
    if (swapImageTarget) {
      const swapLinks = swapElement.querySelectorAll('.js-image-swap-link');
      swapLinks.forEach((swapLinkElement) => {
        const linkImageDataJson = swapLinkElement.querySelector('.js-image-swap-data');
        if (linkImageDataJson) {
          swapLinkElement.addEventListener('mouseover', () => {
            try {
              const imageData = JSON.parse(linkImageDataJson.textContent);
              swapImageTarget.querySelector('img').srcset = imageData.srcset;

              // Pimcore X:
              // Object.keys(data.srcset)
              //   .forEach((mime) => {
              //     const source = swapImageTarget.querySelector(`[type="${mime}"]`);
              //     source.srcset = imageData.srcset[mime];
              //   });
            } catch (e) {
              // psst
            }
          });
        }
      });
    }
  });
}
